module.exports = __webpack_public_path__ + "img/66_6.1e1c0d09.png";